import {Locale} from '../locale';
import {nativeLanguageByLocale} from '../nativeLanguageByLocale';
import {
  ASSETS_URL_DESKTOP_STAGING,
  ASSETS_URL_MOBILE_STAGING,
  IRIS_URL_STAGING,
  KLARNA_SDK_URL_STAGING,
  getDesktopHelpCenterEndpointByLocale,
} from './constants';
import {HttpUrl, UrlMapping} from './types';

const desktopHelpCenterEndpointByLocale =
  getDesktopHelpCenterEndpointByLocale(IRIS_URL_STAGING);

const sendSmsEndpoint = `${IRIS_URL_STAGING}/sms` as HttpUrl;

export const staging: UrlMapping<'staging'> = {
  [Locale.en_ZZ]: {
    environment: 'staging',
    locale: Locale.en_ZZ,
    urlSets: [
      {
        hostname: 'www.aboutyou-staging.com',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_STAGING,
        legacyCheckout: 'https://checkout.aboutyou-staging.com',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.en_ZZ],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        alternateLocales: [
          {
            locale: Locale.es_ZZ,
            url: 'https://es.aboutyou-staging.com',
            nativeLanguage: nativeLanguageByLocale[Locale.es_ZZ],
          },
        ],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.com',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.com/',
      },
      {
        hostname: 'm.aboutyou-staging.com',
        publicDesktopHostname: 'www.aboutyou-staging.com',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_STAGING,
        legacyCheckout: 'https://checkout-m.aboutyou-staging.com',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.en_ZZ],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        alternateLocales: [
          {
            locale: Locale.es_ZZ,
            url: 'https://m-es.aboutyou-staging.com',
            alternateDomainUrl: 'https://es.aboutyou-staging.com',
            nativeLanguage: nativeLanguageByLocale[Locale.es_ZZ],
          },
        ],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.com',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.com/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.es_ZZ]: {
    environment: 'staging',
    locale: Locale.es_ZZ,
    urlSets: [
      {
        hostname: 'es.aboutyou-staging.com',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_STAGING,
        legacyCheckout: 'https://checkout-es.aboutyou-staging.com',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.es_ZZ],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        alternateLocales: [
          {
            locale: Locale.en_ZZ,
            url: 'https://www.aboutyou-staging.com',
            nativeLanguage: nativeLanguageByLocale[Locale.en_ZZ],
          },
        ],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.com',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.com/',
      },
      {
        hostname: 'm-es.aboutyou-staging.com',
        publicDesktopHostname: 'es.aboutyou-staging.com',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_STAGING,
        legacyCheckout: 'https://checkout-m-es.aboutyou-staging.com',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.es_ZZ],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        alternateLocales: [
          {
            locale: Locale.en_ZZ,
            url: 'https://m.aboutyou-staging.com',
            alternateDomainUrl: 'https://www.aboutyou-staging.com',
            nativeLanguage: nativeLanguageByLocale[Locale.en_ZZ],
          },
        ],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.com',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.com/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.de_DE]: {
    environment: 'staging',
    locale: Locale.de_DE,
    urlSets: [
      {
        hostname: 'www.aboutyou-staging.de',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_STAGING,
        legacyCheckout: 'https://checkout.aboutyou-staging.de',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.de_DE],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        alternateLocales: [
          {
            locale: Locale.en_DE,
            url: 'https://en.aboutyou-staging.de',
            nativeLanguage: nativeLanguageByLocale[Locale.en_DE],
          },
        ],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.de',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.de/',
      },
      {
        hostname: 'm.aboutyou-staging.de',
        publicDesktopHostname: 'www.aboutyou-staging.de',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_STAGING,
        legacyCheckout: 'https://checkout-m.aboutyou-staging.de',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.de_DE],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        alternateLocales: [
          {
            locale: Locale.en_DE,
            url: 'https://m-en.aboutyou-staging.de',
            alternateDomainUrl: 'https://en.aboutyou-staging.de',
            nativeLanguage: nativeLanguageByLocale[Locale.en_DE],
          },
        ],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.de',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.de/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.en_DE]: {
    environment: 'staging',
    locale: Locale.en_DE,
    urlSets: [
      {
        hostname: 'en.aboutyou-staging.de',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_STAGING,
        legacyCheckout: 'https://checkout-en.aboutyou-staging.de',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.en_DE],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        alternateLocales: [
          {
            locale: Locale.de_DE,
            url: 'https://www.aboutyou-staging.de',
            nativeLanguage: nativeLanguageByLocale[Locale.de_DE],
          },
        ],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.de',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://en.zalando.de/',
      },
      {
        hostname: 'm-en.aboutyou-staging.de',
        publicDesktopHostname: 'en.aboutyou-staging.de',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_STAGING,
        legacyCheckout: 'https://checkout-m-en.aboutyou-staging.de',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.en_DE],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        alternateLocales: [
          {
            locale: Locale.de_DE,
            url: 'https://m.aboutyou-staging.de',
            alternateDomainUrl: 'https://www.aboutyou-staging.de',
            nativeLanguage: nativeLanguageByLocale[Locale.de_DE],
          },
        ],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.de',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://en.zalando.de/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.de_AT]: {
    environment: 'staging',
    locale: Locale.de_AT,
    urlSets: [
      {
        hostname: 'www.aboutyou-staging.at',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_STAGING,
        legacyCheckout: 'https://checkout.aboutyou-staging.at',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.de_AT],
        sms_POST: sendSmsEndpoint,
        alternateLocales: [
          {
            locale: Locale.en_AT,
            url: 'https://en.aboutyou-staging.at',
            nativeLanguage: nativeLanguageByLocale[Locale.en_AT],
          },
        ],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.at',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.at/',
      },
      {
        hostname: 'm.aboutyou-staging.at',
        publicDesktopHostname: 'www.aboutyou-staging.at',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_STAGING,
        legacyCheckout: 'https://checkout-m.aboutyou-staging.at',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.de_AT],
        sms_POST: sendSmsEndpoint,
        alternateLocales: [
          {
            locale: Locale.en_AT,
            url: 'https://m-en.aboutyou-staging.at',
            alternateDomainUrl: 'https://en.aboutyou-staging.at',
            nativeLanguage: nativeLanguageByLocale[Locale.en_AT],
          },
        ],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.at',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.at/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.en_AT]: {
    environment: 'staging',
    locale: Locale.en_AT,
    urlSets: [
      {
        hostname: 'en.aboutyou-staging.at',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_STAGING,
        legacyCheckout: 'https://checkout-en.aboutyou-staging.at',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.en_AT],
        sms_POST: sendSmsEndpoint,
        alternateLocales: [
          {
            locale: Locale.de_AT,
            url: 'https://www.aboutyou-staging.at',
            nativeLanguage: nativeLanguageByLocale[Locale.de_AT],
          },
        ],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.at',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.at/',
      },
      {
        hostname: 'm-en.aboutyou-staging.at',
        publicDesktopHostname: 'en.aboutyou-staging.at',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_STAGING,
        legacyCheckout: 'https://checkout-m-en.aboutyou-staging.at',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.en_AT],
        sms_POST: sendSmsEndpoint,
        alternateLocales: [
          {
            locale: Locale.de_AT,
            url: 'https://m.aboutyou-staging.at',
            alternateDomainUrl: 'https://www.aboutyou-staging.at',
            nativeLanguage: nativeLanguageByLocale[Locale.de_AT],
          },
        ],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.at',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.at/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.de_CH]: {
    environment: 'staging',
    locale: Locale.de_CH,
    urlSets: [
      {
        hostname: 'www.aboutyou-staging.ch',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_STAGING,
        legacyCheckout: 'https://checkout.aboutyou-staging.ch',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.de_CH],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        alternateLocales: [
          {
            locale: Locale.fr_CH,
            url: 'https://fr.aboutyou-staging.ch',
            nativeLanguage: nativeLanguageByLocale[Locale.fr_CH],
          },
          {
            locale: Locale.it_CH,
            url: 'https://it.aboutyou-staging.ch',
            nativeLanguage: nativeLanguageByLocale[Locale.it_CH],
          },
          {
            locale: Locale.en_CH,
            url: 'https://en.aboutyou-staging.ch',
            nativeLanguage: nativeLanguageByLocale[Locale.en_CH],
          },
        ],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.ch',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.ch/',
      },
      {
        hostname: 'm.aboutyou-staging.ch',
        publicDesktopHostname: 'www.aboutyou-staging.ch',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_STAGING,
        legacyCheckout: 'https://checkout-m.aboutyou-staging.ch',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.de_CH],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        alternateLocales: [
          {
            locale: Locale.fr_CH,
            url: 'https://m-fr.aboutyou-staging.ch',
            alternateDomainUrl: 'https://fr.aboutyou-staging.ch',
            nativeLanguage: nativeLanguageByLocale[Locale.fr_CH],
          },
          {
            locale: Locale.it_CH,
            url: 'https://m-it.aboutyou-staging.ch',
            alternateDomainUrl: 'https://it.aboutyou-staging.ch',
            nativeLanguage: nativeLanguageByLocale[Locale.it_CH],
          },
          {
            locale: Locale.en_CH,
            url: 'https://m-en.aboutyou-staging.ch',
            alternateDomainUrl: 'https://en.aboutyou-staging.ch',
            nativeLanguage: nativeLanguageByLocale[Locale.en_CH],
          },
        ],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.ch',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.ch/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.fr_CH]: {
    environment: 'staging',
    locale: Locale.fr_CH,
    urlSets: [
      {
        hostname: 'fr.aboutyou-staging.ch',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_STAGING,
        legacyCheckout: 'https://checkout-fr.aboutyou-staging.ch',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.fr_CH],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        alternateLocales: [
          {
            locale: Locale.de_CH,
            url: 'https://www.aboutyou-staging.ch',
            nativeLanguage: nativeLanguageByLocale[Locale.de_CH],
          },
          {
            locale: Locale.it_CH,
            url: 'https://it.aboutyou-staging.ch',
            nativeLanguage: nativeLanguageByLocale[Locale.it_CH],
          },
          {
            locale: Locale.en_CH,
            url: 'https://en.aboutyou-staging.ch',
            nativeLanguage: nativeLanguageByLocale[Locale.en_CH],
          },
        ],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.ch',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://fr.zalando.ch/',
      },
      {
        hostname: 'm-fr.aboutyou-staging.ch',
        publicDesktopHostname: 'fr.aboutyou-staging.ch',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_STAGING,
        legacyCheckout: 'https://checkout-m-fr.aboutyou-staging.ch',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.fr_CH],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        alternateLocales: [
          {
            locale: Locale.de_CH,
            url: 'https://m.aboutyou-staging.ch',
            alternateDomainUrl: 'https://www.aboutyou-staging.ch',
            nativeLanguage: nativeLanguageByLocale[Locale.de_CH],
          },
          {
            locale: Locale.it_CH,
            url: 'https://m-it.aboutyou-staging.ch',
            alternateDomainUrl: 'https://it.aboutyou-staging.ch',
            nativeLanguage: nativeLanguageByLocale[Locale.it_CH],
          },
          {
            locale: Locale.en_CH,
            url: 'https://m-en.aboutyou-staging.ch',
            alternateDomainUrl: 'https://en.aboutyou-staging.ch',
            nativeLanguage: nativeLanguageByLocale[Locale.en_CH],
          },
        ],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.ch',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://fr.zalando.ch/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.it_CH]: {
    environment: 'staging',
    locale: Locale.it_CH,
    urlSets: [
      {
        hostname: 'it.aboutyou-staging.ch',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_STAGING,
        legacyCheckout: 'https://checkout-it.aboutyou-staging.ch',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.it_CH],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        alternateLocales: [
          {
            locale: Locale.de_CH,
            url: 'https://www.aboutyou-staging.ch',
            nativeLanguage: nativeLanguageByLocale[Locale.de_CH],
          },
          {
            locale: Locale.fr_CH,
            url: 'https://fr.aboutyou-staging.ch',
            nativeLanguage: nativeLanguageByLocale[Locale.fr_CH],
          },
          {
            locale: Locale.en_CH,
            url: 'https://en.aboutyou-staging.ch',
            nativeLanguage: nativeLanguageByLocale[Locale.en_CH],
          },
        ],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.ch',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://it.zalando.ch/',
      },
      {
        hostname: 'm-it.aboutyou-staging.ch',
        publicDesktopHostname: 'it.aboutyou-staging.ch',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_STAGING,
        legacyCheckout: 'https://checkout-m-it.aboutyou-staging.ch',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.it_CH],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        alternateLocales: [
          {
            locale: Locale.de_CH,
            url: 'https://m.aboutyou-staging.ch',
            alternateDomainUrl: 'https://www.aboutyou-staging.ch',
            nativeLanguage: nativeLanguageByLocale[Locale.de_CH],
          },
          {
            locale: Locale.fr_CH,
            url: 'https://m-fr.aboutyou-staging.ch',
            alternateDomainUrl: 'https://fr.aboutyou-staging.ch',
            nativeLanguage: nativeLanguageByLocale[Locale.fr_CH],
          },
          {
            locale: Locale.en_CH,
            url: 'https://m-en.aboutyou-staging.ch',
            alternateDomainUrl: 'https://en.aboutyou-staging.ch',
            nativeLanguage: nativeLanguageByLocale[Locale.en_CH],
          },
        ],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.ch',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://it.zalando.ch/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.en_CH]: {
    environment: 'staging',
    locale: Locale.en_CH,
    urlSets: [
      {
        hostname: 'en.aboutyou-staging.ch',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_STAGING,
        legacyCheckout: 'https://checkout-en.aboutyou-staging.ch',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.en_CH],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        alternateLocales: [
          {
            locale: Locale.de_CH,
            url: 'https://www.aboutyou-staging.ch',
            nativeLanguage: nativeLanguageByLocale[Locale.de_CH],
          },
          {
            locale: Locale.fr_CH,
            url: 'https://fr.aboutyou-staging.ch',
            nativeLanguage: nativeLanguageByLocale[Locale.fr_CH],
          },
          {
            locale: Locale.it_CH,
            url: 'https://it.aboutyou-staging.ch',
            nativeLanguage: nativeLanguageByLocale[Locale.it_CH],
          },
        ],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.ch',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.ch/',
      },
      {
        hostname: 'm-en.aboutyou-staging.ch',
        publicDesktopHostname: 'en.aboutyou-staging.ch',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_STAGING,
        legacyCheckout: 'https://checkout-m-en.aboutyou-staging.ch',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.en_CH],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        alternateLocales: [
          {
            locale: Locale.de_CH,
            url: 'https://m.aboutyou-staging.ch',
            alternateDomainUrl: 'https://www.aboutyou-staging.ch',
            nativeLanguage: nativeLanguageByLocale[Locale.de_CH],
          },
          {
            locale: Locale.fr_CH,
            url: 'https://m-fr.aboutyou-staging.ch',
            alternateDomainUrl: 'https://fr.aboutyou-staging.ch',
            nativeLanguage: nativeLanguageByLocale[Locale.fr_CH],
          },
          {
            locale: Locale.it_CH,
            url: 'https://m-it.aboutyou-staging.ch',
            alternateDomainUrl: 'https://it.aboutyou-staging.ch',
            nativeLanguage: nativeLanguageByLocale[Locale.it_CH],
          },
        ],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.ch',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.ch/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.nl_NL]: {
    environment: 'staging',
    locale: Locale.nl_NL,
    urlSets: [
      {
        hostname: 'www.aboutyou-staging.nl',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_STAGING,
        legacyCheckout: 'https://checkout.aboutyou-staging.nl',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.nl_NL],
        sms_POST: sendSmsEndpoint,
        alternateLocales: [
          {
            locale: Locale.en_NL,
            url: 'https://en.aboutyou-staging.nl',
            nativeLanguage: nativeLanguageByLocale[Locale.en_NL],
          },
        ],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.nl',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.nl/',
      },
      {
        hostname: 'm.aboutyou-staging.nl',
        publicDesktopHostname: 'www.aboutyou-staging.nl',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_STAGING,
        legacyCheckout: 'https://checkout-m.aboutyou-staging.nl',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.nl_NL],
        sms_POST: sendSmsEndpoint,
        alternateLocales: [
          {
            locale: Locale.en_NL,
            url: 'https://m-en.aboutyou-staging.nl',
            alternateDomainUrl: 'https://en.aboutyou-staging.nl',
            nativeLanguage: nativeLanguageByLocale[Locale.en_NL],
          },
        ],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.nl',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.nl/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.en_NL]: {
    environment: 'staging',
    locale: Locale.en_NL,
    urlSets: [
      {
        hostname: 'en.aboutyou-staging.nl',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_STAGING,
        legacyCheckout: 'https://checkout-en.aboutyou-staging.nl',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.en_NL],
        sms_POST: sendSmsEndpoint,
        alternateLocales: [
          {
            locale: Locale.nl_NL,
            url: 'https://www.aboutyou-staging.nl',
            nativeLanguage: nativeLanguageByLocale[Locale.nl_NL],
          },
        ],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.nl',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://en.zalando.nl/',
      },
      {
        hostname: 'm-en.aboutyou-staging.nl',
        publicDesktopHostname: 'en.aboutyou-staging.nl',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_STAGING,
        legacyCheckout: 'https://checkout-m-en.aboutyou-staging.nl',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.en_NL],
        sms_POST: sendSmsEndpoint,
        alternateLocales: [
          {
            locale: Locale.nl_NL,
            url: 'https://m.aboutyou-staging.nl',
            alternateDomainUrl: 'https://www.aboutyou-staging.nl',
            nativeLanguage: nativeLanguageByLocale[Locale.nl_NL],
          },
        ],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.nl',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://en.zalando.nl/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.pl_PL]: {
    environment: 'staging',
    locale: Locale.pl_PL,
    urlSets: [
      {
        hostname: 'www.aboutyou-staging.pl',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_STAGING,
        legacyCheckout: 'https://checkout.aboutyou-staging.pl',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.pl_PL],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.pl',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.pl/',
      },
      {
        hostname: 'm.aboutyou-staging.pl',
        publicDesktopHostname: 'www.aboutyou-staging.pl',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_STAGING,
        legacyCheckout: 'https://checkout-m.aboutyou-staging.pl',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.pl_PL],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.pl',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.pl/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.nl_BE]: {
    environment: 'staging',
    locale: Locale.nl_BE,
    urlSets: [
      {
        hostname: 'www.aboutyou-staging.be',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_STAGING,
        legacyCheckout: 'https://checkout.aboutyou-staging.be',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.nl_BE],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        alternateLocales: [
          {
            locale: Locale.fr_BE,
            url: 'https://fr.aboutyou-staging.be',
            nativeLanguage: nativeLanguageByLocale[Locale.fr_BE],
          },
        ],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.be',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.be/',
      },
      {
        hostname: 'm.aboutyou-staging.be',
        publicDesktopHostname: 'www.aboutyou-staging.be',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_STAGING,
        legacyCheckout: 'https://checkout-m.aboutyou-staging.be',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.nl_BE],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        alternateLocales: [
          {
            locale: Locale.fr_BE,
            url: 'https://m-fr.aboutyou-staging.be',
            alternateDomainUrl: 'https://fr.aboutyou-staging.be',
            nativeLanguage: nativeLanguageByLocale[Locale.fr_BE],
          },
        ],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.be',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.be/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.fr_BE]: {
    environment: 'staging',
    locale: Locale.fr_BE,
    urlSets: [
      {
        hostname: 'fr.aboutyou-staging.be',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_STAGING,
        legacyCheckout: 'https://checkout-fr.aboutyou-staging.be',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.fr_BE],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        alternateLocales: [
          {
            locale: Locale.nl_BE,
            url: 'https://www.aboutyou-staging.be',
            nativeLanguage: nativeLanguageByLocale[Locale.nl_BE],
          },
        ],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.be',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://fr.zalando.be/',
      },
      {
        hostname: 'm-fr.aboutyou-staging.be',
        publicDesktopHostname: 'fr.aboutyou-staging.be',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_STAGING,
        legacyCheckout: 'https://checkout-m-fr.aboutyou-staging.be',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.fr_BE],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        alternateLocales: [
          {
            locale: Locale.nl_BE,
            url: 'https://m.aboutyou-staging.be',
            alternateDomainUrl: 'https://www.aboutyou-staging.be',
            nativeLanguage: nativeLanguageByLocale[Locale.nl_BE],
          },
        ],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.be',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://fr.zalando.be/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.cs_CZ]: {
    environment: 'staging',
    locale: Locale.cs_CZ,
    urlSets: [
      {
        hostname: 'www.aboutyou-staging.cz',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_STAGING,
        legacyCheckout: 'https://checkout.aboutyou-staging.cz',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.cs_CZ],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.cz',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.cz/',
      },
      {
        hostname: 'm.aboutyou-staging.cz',
        publicDesktopHostname: 'www.aboutyou-staging.cz',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_STAGING,
        legacyCheckout: 'https://checkout-m.aboutyou-staging.cz',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.cs_CZ],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.cz',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.cz/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.ro_RO]: {
    environment: 'staging',
    locale: Locale.ro_RO,
    urlSets: [
      {
        hostname: 'www.aboutyou-staging.ro',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_STAGING,
        legacyCheckout: 'https://checkout.aboutyou-staging.ro',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.ro_RO],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.ro',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.ro/',
      },
      {
        hostname: 'm.aboutyou-staging.ro',
        publicDesktopHostname: 'www.aboutyou-staging.ro',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_STAGING,
        legacyCheckout: 'https://checkout-m.aboutyou-staging.ro',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.ro_RO],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.ro',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.ro/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.hu_HU]: {
    environment: 'staging',
    locale: Locale.hu_HU,
    urlSets: [
      {
        hostname: 'www.aboutyou-staging.hu',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_STAGING,
        legacyCheckout: 'https://checkout.aboutyou-staging.hu',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.hu_HU],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.hu',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.hu/',
      },
      {
        hostname: 'm.aboutyou-staging.hu',
        publicDesktopHostname: 'www.aboutyou-staging.hu',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_STAGING,
        legacyCheckout: 'https://checkout-m.aboutyou-staging.hu',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.hu_HU],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.hu',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.hu/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.sk_SK]: {
    environment: 'staging',
    locale: Locale.sk_SK,
    urlSets: [
      {
        hostname: 'www.aboutyou-staging.sk',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_STAGING,
        legacyCheckout: 'https://checkout.aboutyou-staging.sk',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.sk_SK],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.sk',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.sk/',
      },
      {
        hostname: 'm.aboutyou-staging.sk',
        publicDesktopHostname: 'www.aboutyou-staging.sk',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_STAGING,
        legacyCheckout: 'https://checkout-m.aboutyou-staging.sk',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.sk_SK],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.sk',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.sk/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.sl_SI]: {
    environment: 'staging',
    locale: Locale.sl_SI,
    urlSets: [
      {
        hostname: 'www.aboutyou-staging.si',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_STAGING,
        legacyCheckout: 'https://checkout.aboutyou-staging.si',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.sl_SI],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.si',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.si/',
      },
      {
        hostname: 'm.aboutyou-staging.si',
        publicDesktopHostname: 'www.aboutyou-staging.si',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_STAGING,
        legacyCheckout: 'https://checkout-m.aboutyou-staging.si',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.sl_SI],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.si',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.si/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.lv_LV]: {
    environment: 'staging',
    locale: Locale.lv_LV,
    urlSets: [
      {
        hostname: 'www.aboutyou-staging.lv',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_STAGING,
        legacyCheckout: 'https://checkout.aboutyou-staging.lv',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.lv_LV],
        sms_POST: sendSmsEndpoint,
        alternateLocales: [
          {
            locale: Locale.ru_LV,
            url: 'https://ru.aboutyou-staging.lv',
            nativeLanguage: nativeLanguageByLocale[Locale.ru_LV],
          },
        ],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.lv',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.lv/',
      },
      {
        hostname: 'm.aboutyou-staging.lv',
        publicDesktopHostname: 'www.aboutyou-staging.lv',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_STAGING,
        legacyCheckout: 'https://checkout-m.aboutyou-staging.lv',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.lv_LV],
        sms_POST: sendSmsEndpoint,
        alternateLocales: [
          {
            locale: Locale.ru_LV,
            url: 'https://m-ru.aboutyou-staging.lv',
            alternateDomainUrl: 'https://ru.aboutyou-staging.lv',
            nativeLanguage: nativeLanguageByLocale[Locale.ru_LV],
          },
        ],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.lv',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.lv/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.ru_LV]: {
    environment: 'staging',
    locale: Locale.ru_LV,
    urlSets: [
      {
        hostname: 'ru.aboutyou-staging.lv',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_STAGING,
        legacyCheckout: 'https://checkout-ru.aboutyou-staging.lv',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.ru_LV],
        sms_POST: sendSmsEndpoint,
        alternateLocales: [
          {
            locale: Locale.lv_LV,
            url: 'https://www.aboutyou-staging.lv',
            nativeLanguage: nativeLanguageByLocale[Locale.lv_LV],
          },
        ],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.lv',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.lv/',
      },
      {
        hostname: 'm-ru.aboutyou-staging.lv',
        publicDesktopHostname: 'ru.aboutyou-staging.lv',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_STAGING,
        legacyCheckout: 'https://checkout-m-ru.aboutyou-staging.lv',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.ru_LV],
        sms_POST: sendSmsEndpoint,
        alternateLocales: [
          {
            locale: Locale.lv_LV,
            url: 'https://m.aboutyou-staging.lv',
            alternateDomainUrl: 'https://www.aboutyou-staging.lv',
            nativeLanguage: nativeLanguageByLocale[Locale.lv_LV],
          },
        ],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.lv',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.lv/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.lt_LT]: {
    environment: 'staging',
    locale: Locale.lt_LT,
    urlSets: [
      {
        hostname: 'www.aboutyou-staging.lt',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_STAGING,
        legacyCheckout: 'https://checkout.aboutyou-staging.lt',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.lt_LT],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.lt',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.lt/',
      },
      {
        hostname: 'm.aboutyou-staging.lt',
        publicDesktopHostname: 'www.aboutyou-staging.lt',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_STAGING,
        legacyCheckout: 'https://checkout-m.aboutyou-staging.lt',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.lt_LT],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.lt',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.lt/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.et_EE]: {
    environment: 'staging',
    locale: Locale.et_EE,
    urlSets: [
      {
        hostname: 'www.aboutyou-staging.ee',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_STAGING,
        legacyCheckout: 'https://checkout.aboutyou-staging.ee',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.et_EE],
        sms_POST: sendSmsEndpoint,
        alternateLocales: [
          {
            locale: Locale.ru_EE,
            url: 'https://ru.aboutyou-staging.ee',
            nativeLanguage: nativeLanguageByLocale[Locale.ru_EE],
          },
        ],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.ee',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.ee/',
      },
      {
        hostname: 'm.aboutyou-staging.ee',
        publicDesktopHostname: 'www.aboutyou-staging.ee',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_STAGING,
        legacyCheckout: 'https://checkout-m.aboutyou-staging.ee',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.et_EE],
        sms_POST: sendSmsEndpoint,
        alternateLocales: [
          {
            locale: Locale.ru_EE,
            url: 'https://m-ru.aboutyou-staging.ee',
            alternateDomainUrl: 'https://ru.aboutyou-staging.ee',
            nativeLanguage: nativeLanguageByLocale[Locale.ru_EE],
          },
        ],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.ee',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.ee/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.ru_EE]: {
    environment: 'staging',
    locale: Locale.ru_EE,
    urlSets: [
      {
        hostname: 'ru.aboutyou-staging.ee',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_STAGING,
        legacyCheckout: 'https://checkout-ru.aboutyou-staging.ee',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.ru_EE],
        sms_POST: sendSmsEndpoint,
        alternateLocales: [
          {
            locale: Locale.et_EE,
            url: 'https://www.aboutyou-staging.ee',
            nativeLanguage: nativeLanguageByLocale[Locale.et_EE],
          },
        ],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.ee',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.ee/',
      },
      {
        hostname: 'm-ru.aboutyou-staging.ee',
        publicDesktopHostname: 'ru.aboutyou-staging.ee',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_STAGING,
        legacyCheckout: 'https://checkout-m-ru.aboutyou-staging.ee',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.ru_EE],
        sms_POST: sendSmsEndpoint,
        alternateLocales: [
          {
            locale: Locale.et_EE,
            url: 'https://m.aboutyou-staging.ee',
            alternateDomainUrl: 'https://www.aboutyou-staging.ee',
            nativeLanguage: nativeLanguageByLocale[Locale.et_EE],
          },
        ],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.ee',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.ee/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.hr_HR]: {
    environment: 'staging',
    locale: Locale.hr_HR,
    urlSets: [
      {
        hostname: 'www.aboutyou-staging.hr',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_STAGING,
        legacyCheckout: 'https://checkout.aboutyou-staging.hr',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.hr_HR],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.hr',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.hr/',
      },
      {
        hostname: 'm.aboutyou-staging.hr',
        publicDesktopHostname: 'www.aboutyou-staging.hr',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_STAGING,
        legacyCheckout: 'https://checkout-m.aboutyou-staging.hr',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.hr_HR],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.hr',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.hr/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.bg_BG]: {
    environment: 'staging',
    locale: Locale.bg_BG,
    urlSets: [
      {
        hostname: 'www.aboutyou-staging.bg',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_STAGING,
        legacyCheckout: 'https://checkout.aboutyou-staging.bg',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.bg_BG],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.bg',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.com/',
      },
      {
        hostname: 'm.aboutyou-staging.bg',
        publicDesktopHostname: 'www.aboutyou-staging.bg',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_STAGING,
        legacyCheckout: 'https://checkout-m.aboutyou-staging.bg',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.bg_BG],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.bg',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.com/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.fr_FR]: {
    environment: 'staging',
    locale: Locale.fr_FR,
    urlSets: [
      {
        hostname: 'www.aboutyou-staging.fr',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_STAGING,
        legacyCheckout: 'https://checkout.aboutyou-staging.fr',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.fr_FR],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.fr',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.fr/',
      },
      {
        hostname: 'm.aboutyou-staging.fr',
        publicDesktopHostname: 'www.aboutyou-staging.fr',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_STAGING,
        legacyCheckout: 'https://checkout-m.aboutyou-staging.fr',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.fr_FR],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.fr',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.fr/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.da_DK]: {
    environment: 'staging',
    locale: Locale.da_DK,
    urlSets: [
      {
        hostname: 'www.aboutyou-staging.dk',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_STAGING,
        legacyCheckout: 'https://checkout.aboutyou-staging.dk',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.da_DK],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.dk',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.dk/',
      },
      {
        hostname: 'm.aboutyou-staging.dk',
        publicDesktopHostname: 'www.aboutyou-staging.dk',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_STAGING,
        legacyCheckout: 'https://checkout-m.aboutyou-staging.dk',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.da_DK],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.dk',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.dk/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.sv_SE]: {
    environment: 'staging',
    locale: Locale.sv_SE,
    urlSets: [
      {
        hostname: 'www.aboutyou-staging.se',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_STAGING,
        legacyCheckout: 'https://checkout.aboutyou-staging.se',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.sv_SE],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.se',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.se/',
      },
      {
        hostname: 'm.aboutyou-staging.se',
        publicDesktopHostname: 'www.aboutyou-staging.se',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_STAGING,
        legacyCheckout: 'https://checkout-m.aboutyou-staging.se',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.sv_SE],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.se',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.se/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.fi_FI]: {
    environment: 'staging',
    locale: Locale.fi_FI,
    urlSets: [
      {
        hostname: 'www.aboutyou-staging.fi',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_STAGING,
        legacyCheckout: 'https://checkout.aboutyou-staging.fi',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.fi_FI],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.fi',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.fi/',
      },
      {
        hostname: 'm.aboutyou-staging.fi',
        publicDesktopHostname: 'www.aboutyou-staging.fi',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_STAGING,
        legacyCheckout: 'https://checkout-m.aboutyou-staging.fi',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.fi_FI],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.fi',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.fi/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.es_ES]: {
    environment: 'staging',
    locale: Locale.es_ES,
    urlSets: [
      {
        hostname: 'www.aboutyou-staging.es',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_STAGING,
        legacyCheckout: 'https://checkout.aboutyou-staging.es',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.es_ES],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.es',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.es/',
      },
      {
        hostname: 'm.aboutyou-staging.es',
        publicDesktopHostname: 'www.aboutyou-staging.es',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_STAGING,
        legacyCheckout: 'https://checkout-m.aboutyou-staging.es',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.es_ES],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.es',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.es/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.it_IT]: {
    environment: 'staging',
    locale: Locale.it_IT,
    urlSets: [
      {
        hostname: 'www.aboutyou-staging.it',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_STAGING,
        legacyCheckout: 'https://checkout.aboutyou-staging.it',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.it_IT],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.it',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.it/',
      },
      {
        hostname: 'm.aboutyou-staging.it',
        publicDesktopHostname: 'www.aboutyou-staging.it',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_STAGING,
        legacyCheckout: 'https://checkout-m.aboutyou-staging.it',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.it_IT],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.it',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.it/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.pt_PT]: {
    environment: 'staging',
    locale: Locale.pt_PT,
    urlSets: [
      {
        hostname: 'www.aboutyou-staging.pt',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_STAGING,
        legacyCheckout: 'https://checkout.aboutyou-staging.pt',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.pt_PT],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.pt',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.pt/',
      },
      {
        hostname: 'm.aboutyou-staging.pt',
        publicDesktopHostname: 'www.aboutyou-staging.pt',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_STAGING,
        legacyCheckout: 'https://checkout-m.aboutyou-staging.pt',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.pt_PT],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.pt',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.pt/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.el_GR]: {
    environment: 'staging',
    locale: Locale.el_GR,
    urlSets: [
      {
        hostname: 'www.aboutyou-staging.gr',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_STAGING,
        legacyCheckout: 'https://checkout.aboutyou-staging.gr',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.el_GR],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.gr',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.com/',
      },
      {
        hostname: 'm.aboutyou-staging.gr',
        publicDesktopHostname: 'www.aboutyou-staging.gr',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_STAGING,
        legacyCheckout: 'https://checkout-m.aboutyou-staging.gr',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.el_GR],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.gr',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.com/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.el_CY]: {
    environment: 'staging',
    locale: Locale.el_CY,
    urlSets: [
      {
        hostname: 'www.aboutyou-staging.com.cy',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_STAGING,
        legacyCheckout: 'https://checkout.aboutyou-staging.com.cy',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.el_CY],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.com.cy',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.com/',
      },
      {
        hostname: 'm.aboutyou-staging.com.cy',
        publicDesktopHostname: 'www.aboutyou-staging.com.cy',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_STAGING,
        legacyCheckout: 'https://checkout-m.aboutyou-staging.com.cy',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.el_CY],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.com.cy',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.com/',
      },
    ],
  },
  [Locale.fr_LU]: {
    environment: 'staging',
    locale: Locale.fr_LU,
    urlSets: [
      {
        hostname: 'www.aboutyou-staging.lu',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_STAGING,
        legacyCheckout: 'https://checkout.aboutyou-staging.lu',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.fr_LU],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.lu',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.lu/',
      },
      {
        hostname: 'm.aboutyou-staging.lu',
        publicDesktopHostname: 'www.aboutyou-staging.lu',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_STAGING,
        legacyCheckout: 'https://checkout-m.aboutyou-staging.lu',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.fr_LU],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.lu',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.lu/',
      },
    ],
    genderCookieSameDomain: true,
  },
};
